// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/fc7ac31e/" + chunkId + "." + __webpack_require__.h() + ".vfc7ac31e.js";
};